import { render, staticRenderFns } from "./SubmerchantUserFragment.vue?vue&type=template&id=e42417c0&"
import script from "./SubmerchantUserFragment.vue?vue&type=script&lang=js&"
export * from "./SubmerchantUserFragment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports